import { Button, Spin } from "antd";
import React, { Component } from "react";
import { FaPen } from "react-icons/fa";
import { connect } from "react-redux";
import { GetRequestDetailsAction } from "../../redux/order/order.action";
import PropertyDetails from "../PropertyDetails/PropertyDetails";

class ClientProperty extends Component {
  state = {
    showAdd: false,
    userData:this.props.userData,
  };
  handelShowInfo = (body) => {
    this.setState({showAdd: false});
    //console.log('body',body);
    this.setState({userData:{...this.state.userData,RealestateFinancingRequest:body.RealestateFinancingRequest,
      PersonalFinancingRequest:body.PersonalFinancingRequest}})
}

  render() {
    const { userData } = this.state;

    return (
      <div className="client-info-wrapper">
        <header className="client-header">
          <h2 className="header-title">بيانات التمويل</h2>
          {!this.state.showAdd && userData?.RealestateFinancingRequest==null && 
          <div className="header-btn-holder">
            <Button
              type="primary"
              size="large"
              ghost
              className="blue-btn"
              onClick={() => this.setState({showAdd : true}) }
              icon={<FaPen />}
              >
              تعديل
            </Button>
          </div> 
            }
        </header>
        {this.state.showAdd ? <PropertyDetails userData={userData} handelShowInfo={this.handelShowInfo} editMode={true} showAdd={this.state.showAdd} /> : (this.props.RequestDetails!=null?
       (

        
          <>
            {userData?.RealestateFinancingRequest != null && 
              <div className="collapse-show-holder">
                <div className="collapse-show-header">تمويل عقاري</div>
                <div className="info-grid">
                  <div className="info-grid-cell">
                    <p className="info-cell-p">نوع المالك</p>
                    <h6 className="info-cell-val">وسيط</h6>
                  </div>
                  <div className="info-grid-cell">
                    <p className="info-cell-p">اسم المالك</p>
                    <h6 className="info-cell-val">{userData?.RealestateFinancingRequest.OwnerName}</h6>
                  </div>
                  <div className="info-grid-cell">
                    <p className="info-cell-p">رقم الجوال</p>
                    <h6 className="info-cell-val">{+userData?.RealestateFinancingRequest?.OwnerPhoneKey + userData?.RealestateFinancingRequest?.OwnerPhoneNumber}</h6>

                  </div>
                  <div className="info-grid-cell">
                    <p className="info-cell-p">الوقت المناسب للاتصال</p>
                    <h6 className="info-cell-val">{userData?.RealestateFinancingRequest?.TimeToContact}</h6>
                  </div>
                  <div className="info-grid-cell">
                    <p className="info-cell-p">سعر العقار الفعلي</p>
                    <h6 className="info-cell-val">{userData?.RealestateFinancingRequest?.RealestatePrice} ر.س</h6>
                  </div>
                  <div className="info-grid-cell">
                    <p className="info-cell-p">نسبة اكتمال بناء العقار</p>
                    <h6 className="info-cell-val">{userData?.RealestateFinancingRequest?.RealestateCompleteProgress} %</h6>
                  </div>
                  <div className="info-grid-cell">
                    <p className="info-cell-p">رقم الصك</p>
                    <h6 className="info-cell-val">{userData?.RealestateFinancingRequest?.InstrumentNo}</h6>
                  </div>
                  <div className="info-grid-cell">
                    <p className="info-cell-p">رابط العقار المقترح</p>
                    <h6 className="info-cell-val">{userData?.RealestateFinancingRequest?.RealestateUrl}</h6>
                  </div>
                </div>
              </div>
            }

            {userData?.PersonalFinancingRequest != null && 
              <div className="collapse-show-holder" style={{ marginBottom: 10 }}>
                <div className="collapse-show-header">تمويل شخصي</div>
                <div className="info-grid">
                  <div className="info-grid-cell">
                    <p className="info-cell-p">المبلغ</p>
                    <h6 className="info-cell-val">{userData?.PersonalFinancingRequest?.Amount} ر.س</h6>
                  </div>
                </div>
              </div>
            }
          </>):<div style={{width:"100%",display:"flex",justifyContent:"center",alignItems:"center",height:"200px"}}><Spin size="large" /></div>)}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  FinanceRequestSources : state.user.metaData.FinanceRequestSources,
  ServiceTypes : state.user.metaData.ServiceTypes,
  RequestDetails:state.order.RequestDetails

}) 
const mapDispatchToProps = (dispatch) => ({
  GetRequestDetailsAction:(data)=>dispatch(GetRequestDetailsAction(data)),
})
export default connect(mapStateToProps,mapDispatchToProps)(ClientProperty);  